<main class="app_template_b__container" id="templateContainer">
	<app-print-header></app-print-header>
	<p-dialog [(visible)]="displayAgentes" [style]="{ width: '600px', height: '300px' }" [modal]="true">
		<ng-template pTemplate="header">
			<label><strong>Esops de exposición: </strong>
				{{ examen.esops?.length }}</label>
		</ng-template>
		<p-scrollPanel [style]="{ height: '200px' }">
			<p-table [value]="examen.esops">
				<ng-template pTemplate="header">
					<tr>
						<th style="width: 20%; text-align: center;">Código</th>
						<th style="width: 80%; text-align: center;">Concepto</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
					<tr>
						<td style="text-align: center;">{{ item.codigo }}</td>
						<td style="text-align: center;">{{ item.descripcion }}</td>
					</tr>
				</ng-template>
			</p-table>
		</p-scrollPanel>
		<p-footer>
			<p-button type="button" label="Regresar al examen" (click)="displayAgentes = false"></p-button>
		</p-footer>
	</p-dialog>


	<form (ngSubmit)="onSubmit()" *ngIf="examForm" [formGroup]="examForm" id="idFormLogin" name="formLogin">
		<div class="form-container p-fluid">


			<div class="p-grid p-jc-between" style="margin-bottom: 15px;">
				<div class="" style="display: flex;">
					<span>
						<i (click)="goBack()" class="pi pi-arrow-left"
							style="font-size: 1rem; margin-right: 10px; cursor: pointer;"></i>
					</span>
					<label class="p-title-seccion form-examen-name-title">{{configForm.name}}</label>
				</div>

				<span class="print_hide-on-print">
					<app-print-button></app-print-button>
				</span>
			</div>

			<div class="p-grid">
				<div *ngIf="configForm.findField('fechaRealizacion')" class="p-field p-col-12 p-md-3">
					<app-fiel-title label="Fecha de realización" required="true"></app-fiel-title>
					<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
						{{examForm.controls.fechaRealizacion.value | date:"dd/MM/yyyy"}}
					</span>

					<p-calendar formControlName="fechaRealizacion" [showIcon]="true" dataType="date"
						dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" id="date_init" inputId="range" name="date_init"
						[maxDate]="maxDate" [minDate]="minDate" class="print_hide-on-print"
						[ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaRealizacion.invalid}"
						[disabled]="examen?.modoVista === 'ver'">
					</p-calendar>

					<app-invalid-from-message *ngIf="submitted && f.fechaRealizacion.invalid">
					</app-invalid-from-message>
				</div>


				<div class="p-field p-col-12 p-md-2">
					<app-fiel-title label="Nro. Lote"></app-fiel-title>
					<p class="readOnly">
						{{examen.lote.numeroLote}}
					</p>
				</div>


				<div class="p-field p-col-12 p-md-2">
					<app-fiel-title label="Nro. Carpeta"></app-fiel-title>
					<p class="readOnly">
						{{examen.numeroCarpeta}}
					</p>
				</div>

				<div class="p-col-12 p-md-3 print_hide-on-print custom-agentes">
					<label class="color-text" (click)="displayAgentes = true">
						Esops de exposición ({{ examen.esops?.length }})</label>
				</div>
			</div>


			<div *ngIf="configForm.findSection('Empleador')">
				<div class="p-grid p-mt-2">
					<label class="p-title-seccion">
						{{ configForm.findNumberSection("Empleador") }}. Datos de la empresa
					</label>
				</div>
				<p-divider></p-divider>
				<div class="p-grid">
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Razón Social"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.empresa.razonSocial }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="CUIT"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.empresa.cuit }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Establecimiento"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.establecimiento?.nombre }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Teléfono"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.establecimiento?.telefono }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4 print_row-full">
						<app-fiel-title label="Dirección de E-mail"></app-fiel-title>
						<p class="readOnly p-field-word-break">{{ examen.lote.establecimiento?.mail }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4 print_row-full">
						<app-fiel-title label="Domicilio"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.establecimiento?.domicilio }}</p>
					</div>
				</div>
			</div>


			<div *ngIf="configForm.findSection('Trabajador')">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("Trabajador") }}. Datos Del Trabajador
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-grid p-grid-space">
					<div class="p-field p-col-12 p-md-4 print_row-full">
						<app-fiel-title label="Apellido y nombre" required="true"></app-fiel-title>
						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.apellidoNombre.invalid}" alfanumericoDirective
						  formControlName="apellidoNombre" id="apellidoNombre" name="apellidoNombre" maxlength="100" pInputText type="text"
						  [attr.disabled]="examen?.modoVista === 'ver' || deshabilitarApellidoNombreTrabajador() ? true : null" />
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
						  {{examForm.controls.apellidoNombre.value}}
						</span>
						<app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.required"></app-invalid-from-message>
						<app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.apellidoNombreTrabajadorValidator"
											message="{{ f.apellidoNombre.errors?.apellidoNombreTrabajadorValidatorMessage }}">
										</app-invalid-from-message>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="CUIL"></app-fiel-title>
						<p class="readOnly">
							{{examen.trabajador.cuil}}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Fecha de nacimiento" required="true"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
						  {{examForm.controls.fechaNacimiento.value | date: "dd/MM/yyyy"}}
						</span>
						<p-calendar formControlName="fechaNacimiento" [showIcon]="true" dateFormat="dd/mm/yy"
						  placeholder="dd/mm/yyyy" name="fechaNacimiento" [maxDate]="maxDate" class="print_hide-on-print"
						  [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaNacimiento.invalid}"
						  (onSelect)="calculateAge()" (onBlur)="calculateAge()"
						  [disabled]="examen?.modoVista === 'ver' || examen.trabajador.fechaNacimiento">
						</p-calendar>
						<app-invalid-from-message *ngIf="submitted && f.fechaNacimiento.invalid"></app-invalid-from-message>
					  </div>
					<div class="p-field p-col-12 p-md-4 p_hidden">
						<app-fiel-title label="DNI"></app-fiel-title>
						<p class="readOnly">
							{{examen.trabajador.numeroDocumento}}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4 p_hidden">
						<app-fiel-title label="Sexo"></app-fiel-title>
						<p class="readOnly">
							{{examen.trabajador.sexo}}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4 print_row-full p_hidden">
						<app-fiel-title label="Domicilio"></app-fiel-title>
						<p class="readOnly">
							{{ getDescripcionDomicilio() }}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4 p_hidden">
						<app-fiel-title label="Edad"></app-fiel-title>
						<p class="readOnly">
							{{ examen.trabajador.edad }} años
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Puesto de trabajo" required="true"></app-fiel-title>
						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.puestoTrabajador.invalid}"
							alfanumericoDirective formControlName="puestoTrabajador" id="puesto" name="puesto"
							maxlength="100" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
							{{examForm.controls.puestoTrabajador.value}}
						</span>
						<app-invalid-from-message *ngIf="submitted && f.puestoTrabajador.invalid">
						</app-invalid-from-message>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Fecha de ingreso a la empresa" required="true"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
							{{examForm.controls.fechaIngresoEmpresa.value | date: "dd/MM/yyyy"}}
						</span>
						<p-calendar formControlName="fechaIngresoEmpresa" [showIcon]="true" dateFormat="dd/mm/yy"
							placeholder="dd/mm/yyyy" name="ingresoEmpresaDate" [maxDate]="maxDateIngreso"
							class="print_hide-on-print"
							[ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaIngresoEmpresa.invalid}"
							[disabled]="examen?.modoVista === 'ver'">
						</p-calendar>
						<app-invalid-from-message *ngIf="submitted && f.fechaIngresoEmpresa.invalid">
						</app-invalid-from-message>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Fecha de ingreso al puesto" required="true"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
							{{examForm.controls.antiguedadPuestoTrabajador.value | date: "dd/MM/yyyy"}}
						</span>
						<p-calendar formControlName="antiguedadPuestoTrabajador" [showIcon]="true" dateFormat="dd/mm/yy"
							placeholder="dd/mm/yyyy" name="antiguedadDate" class="print_hide-on-print"
							[ngClass]="{'ng-invalid ng-dirty': submitted && f.antiguedadPuestoTrabajador.invalid}"
							[disabled]="examen?.modoVista === 'ver'" [maxDate]="maxDate"
							[minDate]="this.examForm.controls.fechaIngresoEmpresa.value"
							(onSelect)="restrictDateIngresoEmpresa()" (onBlur)="restrictDateIngresoEmpresa()">
						</p-calendar>
						<app-invalid-from-message *ngIf="submitted && f.antiguedadPuestoTrabajador.invalid">
						</app-invalid-from-message>
					</div>
				</div>
			</div>


			<div *ngIf="configForm.findSection('HistorialLaboral')">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("HistorialLaboral") }}. Historial Laboral
					</span>
				</div>
				<p-divider></p-divider>

				<div class="p-col-12 p-md-12 print_dont_break">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Exposiciones anteriores: " required="true"></app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('expAntSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('expAntSi', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.expAntSi.value && !f.expAntNo.value}"
										formControlName="expAntSi" inputId="expAntSi"
										label="Si" name="expAntSi"
										[ngModel]="examen.expAnt"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('expAntNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('expAntNo', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.expAntSi.value && !f.expAntNo.value}"
										formControlName="expAntNo" inputId="expAntNo"
										label="No" name="expAntNo"
										[ngModel]="examen.expAnt === false"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
						<div class="p-col-12 p-md-12">
							<app-invalid-from-message *ngIf="submitted && !f.expAntSi.value  && !f.expAntNo.value">
							</app-invalid-from-message>
						</div>
					</div>
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Describa: " [required]="f.expAntSi.value"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('expAntDesc')" class="p-col-12 p-md-6 print_row-full">
							<p [ngClass]="{'print_show-on-print': f.expAntDesc.value.length > 0 && f.expAntSi.value,
							   'print_hide-on-print': f.expAntDesc.value.length < 1 }"
							   class="print_hidden-area-before-print print_row-full p-field-word-break">
							   {{f.expAntDesc.value}}
							</p>
							<textarea class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.expAntDesc.invalid}"
								cols="30" formControlName="expAntDesc" id="result" maxlength="250" name="resul" pInputTextarea rows="5"
								[attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.expAntDesc.value.length }}/250
							</small>
							<app-invalid-from-message *ngIf="submitted && f.expAntDesc.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.expAntDesc.errors?.maxlength"
								message="Solo se permiten {{ f.expAntDesc.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
				<div class="p-col-12 p-md-12 print_dont_break">
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Descripción de la tarea que realiza"></app-fiel-title>
						</div>
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Riesgo: "></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('riesgo')" class="p-col-12 p-md-6 print_row-full">
							<p [ngClass]="{'print_show-on-print': f.riesgo.value.length > 0,
								'print_hide-on-print': f.riesgo.value.length < 1 }"
							   class="print_hidden-area-before-print print_row-full p-field-word-break">
							   {{f.riesgo.value}}
							</p>
							<textarea class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.riesgo.invalid}"
								cols="30" formControlName="riesgo" id="result" maxlength="250" name="resul" pInputTextarea rows="5"
								[attr.disabled]="true">
					              </textarea>
							<small style="text-align: end;">
								{{ f.riesgo.value.length }}/250
							</small>
							<app-invalid-from-message *ngIf="submitted && f.riesgo.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.riesgo.errors?.maxlength"
								message="Solo se permiten {{ f.riesgo.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>

				<div class="p-col-12 p-md-12 print_dont_break">
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Sustancias con las que trabaja: " required="true"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('sustTrab')"
							class="p-col-12 p-md-6 print_row-full">
							<p [ngClass]="{'print_show-on-print': f.sustTrab.value.length > 0,
							   'print_hide-on-print': f.sustTrab.value.length < 1 }"
							   class="print_hidden-area-before-print print_row-full p-field-word-break">
							   {{f.sustTrab.value}}
							</p>
							<textarea class="print_hide-on-print"
								[ngClass]="{'ng-invalid ng-dirty': submitted && f.sustTrab.invalid}"
								cols="30" formControlName="sustTrab" id="result" maxlength="250"
								name="resul" pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
				              </textarea>
							<small style="text-align: end;">
								{{ f.sustTrab.value.length }}/250
							</small>
							<app-invalid-from-message *ngIf="submitted && f.sustTrab.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.sustTrab.errors?.maxlength"
								message="Solo se permiten {{ f.sustTrab.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>

				<div class="p-col-12 p-md-12 print_dont_break">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Elemento de protección: " required="true"></app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('elemProtSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('elemProtSi', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.elemProtSi.value && !f.elemProtNo.value}"
										formControlName="elemProtSi" inputId="elemProtSi"
										label="Si" name="elemProtSi"
										[ngModel]="examen.elemProt"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('elemProtNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('elemProtNo', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.elemProtSi.value && !f.elemProtNo.value}"
										formControlName="elemProtNo" inputId="elemProtNo"
										label="No" name="elemProtNo"
										[ngModel]="examen.elemProt === false"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
						<div class="p-col-12 p-md-12">
							<app-invalid-from-message *ngIf="submitted && !f.elemProtSi.value  && !f.elemProtNo.value">
							</app-invalid-from-message>
						</div>
					</div>
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Cuál: " [required]="f.elemProtSi.value"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('elemProtCual')" class="p-col-12 p-md-6 print_row-full">
							<p [ngClass]="{'print_show-on-print': f.elemProtCual.value.length > 0 && f.elemProtSi.value,
								'print_hide-on-print': f.elemProtCual.value.length < 1 }"
							   class="print_hidden-area-before-print print_row-full p-field-word-break">
							   {{f.elemProtCual.value}}
							</p>
							<textarea class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.elemProtCual.invalid}"
								cols="30" formControlName="elemProtCual" id="result" maxlength="250" name="resul" pInputTextarea rows="5"
								[attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.elemProtCual.value.length }}/250
							</small>
							<app-invalid-from-message *ngIf="submitted && f.elemProtCual.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.elemProtCual.errors?.maxlength"
								message="Solo se permiten {{ f.elemProtCual.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>

			</div>


			<div *ngIf="configForm.findSection('HistorialDermatologico')" class="print_dont_break">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("HistorialDermatologico") }}. Historial Dermatológico
					</span>
				</div>
				<p-divider></p-divider>

				<div class="p-col-12 p-md-12">
					<div class="p-grid">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Antecedentes de enfermedades dermatológicas de origen no laboral: " required="true"></app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('antEnfDerSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('antEnfDerSi', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.antEnfDerSi.value && !f.antEnfDerNo.value}"
										formControlName="antEnfDerSi" inputId="antEnfDerSi"
										label="Si" name="antEnfDerSi"
										[ngModel]="examen.antEnfDer"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('antEnfDerNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('antEnfDerNo', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.antEnfDerSi.value && !f.antEnfDerNo.value}"
										formControlName="antEnfDerNo" inputId="antEnfDerNo"
										label="No" name="antEnfDerNo"
										[ngModel]="examen.antEnfDer === false"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
						<div class="p-col-12 p-md-12">
							<app-invalid-from-message *ngIf="submitted && !f.antEnfDerSi.value  && !f.antEnfDerNo.value">
							</app-invalid-from-message>
						</div>
					</div>
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Cuál: " [required]="f.antEnfDerSi.value"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('antEnfDerCual')" class="p-col-12 p-md-6 print_row-full">
							<p [ngClass]="{'print_show-on-print': f.antEnfDerCual.value.length > 0 && f.antEnfDerSi.value,
								'print_hide-on-print': f.antEnfDerCual.value.length < 1 }"
							   class="print_hidden-area-before-print print_row-full p-field-word-break">
							   {{f.antEnfDerCual.value}}
							</p>
							<textarea class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.antEnfDerCual.invalid}"
								cols="30" formControlName="antEnfDerCual" id="result" maxlength="250" name="resul" pInputTextarea rows="5"
								[attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.antEnfDerCual.value.length }}/250
							</small>
							<app-invalid-from-message *ngIf="submitted && f.antEnfDerCual.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.antEnfDerCual.errors?.maxlength"
								message="Solo se permiten {{ f.antEnfDerCual.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="configForm.findSection('EstudioDermatologicoActual')">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("EstudioDermatologicoActual") }}. Estudio Dermatológico Actual
					</span>
				</div>
				<p-divider></p-divider>

				<div class="p-col-12 p-md-12">
					<div class="p-grid print_dont_break">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="¿Tiene lesiones?: " required="true"></app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('lesionSi')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('lesionSi', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.lesionSi.value && !f.lesionNo.value}"
										formControlName="lesionSi" inputId="lesionSi"
										label="Si" name="lesionSi"
										[ngModel]="examen.lesion"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('lesionNo')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('lesionNo', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.lesionSi.value && !f.lesionNo.value}"
										formControlName="lesionNo" inputId="lesionNo"
										label="No" name="lesionNo"
										[ngModel]="examen.lesion === false"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
						<div class="p-col-12 p-md-12">
							<app-invalid-from-message *ngIf="submitted && !f.lesionSi.value  && !f.lesionNo.value">
							</app-invalid-from-message>
						</div>
					</div>
					<div class="p-grid print_dont_break">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Localización de la lesión: " [required]="f.lesionSi.value"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('lesionLoc')" class="p-col-12 p-md-6 print_row-full">
							<p [ngClass]="{'print_show-on-print': f.lesionLoc.value.length > 0 && f.lesionSi.value,
							   'print_hide-on-print': f.lesionLoc.value.length < 1 }"
							   class="print_hidden-area-before-print print_row-full p-field-word-break">
							   {{f.lesionLoc.value}}
							</p>
							<textarea class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.lesionLoc.invalid}"
								cols="30" formControlName="lesionLoc" id="result" maxlength="250" name="resul" pInputTextarea rows="5"
								[attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.lesionLoc.value.length }}/250
							</small>
							<app-invalid-from-message *ngIf="submitted && f.lesionLoc.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.lesionLoc.errors?.maxlength"
								message="Solo se permiten {{ f.lesionLoc.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
					<div class="p-grid print_dont_break">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Extensión: " [required]="f.lesionSi.value"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('lesionExt')" class="p-col-12 p-md-6 print_row-full">
							<p [ngClass]="{'print_show-on-print': f.lesionExt.value.length > 0 && f.lesionSi.value,
								'print_hide-on-print': f.lesionExt.value.length < 1 }"
							   class="print_hidden-area-before-print print_row-full p-field-word-break">
							   {{f.lesionExt.value}}
							</p>
							<textarea class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.lesionExt.invalid}"
								cols="30" formControlName="lesionExt" id="result" maxlength="250" name="resul" pInputTextarea rows="5"
								[attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.lesionExt.value.length }}/250
							</small>
							<app-invalid-from-message *ngIf="submitted && f.lesionExt.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.lesionExt.errors?.maxlength"
								message="Solo se permiten {{ f.lesionExt.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
					<div class="p-grid print_dont_break">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Descripción de la/s lesión/es: " [required]="f.lesionSi.value"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('lesionDesc')" class="p-col-12 p-md-6 print_row-full">
							<p [ngClass]="{'print_show-on-print': f.lesionDesc.value.length > 0 && f.lesionSi.value,
								'print_hide-on-print': f.lesionDesc.value.length < 1 }"
							   class="print_hidden-area-before-print print_row-full p-field-word-break">
							   {{f.lesionDesc.value}}
							</p>
							<textarea class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.lesionDesc.invalid}"
								cols="30" formControlName="lesionDesc" id="result" maxlength="1000" name="resul" pInputTextarea rows="5"
								[attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.lesionDesc.value.length }}/1000
							</small>
							<app-invalid-from-message *ngIf="submitted && f.lesionDesc.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.lesionDesc.errors?.maxlength"
								message="Solo se permiten {{ f.lesionDesc.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
					<div class="p-grid print_dont_break">
						<div class="p-col-12 p-md-4">
							<app-fiel-title label="Restos de piel y anexos: " required="true"></app-fiel-title>
						</div>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('restNorm')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('restNorm', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.restNorm.value && !f.restPat.value}"
										formControlName="restNorm" inputId="restNorm"
										label="Normal" name="restNorm"
										[ngModel]="examen.restNorm"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('restPat')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox">
									<p-checkbox (onChange)="clickCheckBox('restPat', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.restNorm.value && !f.restPat.value}"
										formControlName="restPat" inputId="restPat"
										label="Patológico" name="restPat"
										[ngModel]="examen.restPat"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
						<div class="p-col-12 p-md-12">
							<app-invalid-from-message *ngIf="submitted && !f.restNorm.value  && !f.restPat.value">
							</app-invalid-from-message>
						</div>
					</div>
					<div class="p-grid print_dont_break">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Describa: " [required]="f.restPat.value"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('restDesc')" class="p-col-12 p-md-6 print_row-full">
							<p [ngClass]="{'print_show-on-print': f.restDesc.value.length > 0 && f.restPat.value,
								'print_hide-on-print': f.restDesc.value.length < 1 }"
							   class="print_hidden-area-before-print print_row-full p-field-word-break">
							   {{f.restDesc.value}}
							</p>
							<textarea class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.restDesc.invalid}"
								cols="30" formControlName="restDesc" id="result" maxlength="250" name="resul" pInputTextarea rows="5"
								[attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.restDesc.value.length }}/250
							</small>
							<app-invalid-from-message *ngIf="submitted && f.restDesc.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.restDesc.errors?.maxlength"
								message="Solo se permiten {{ f.restDesc.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="configForm.findSection('Diagnostico')" class="print_dont_break">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("Diagnostico") }}. Diagnóstico
					</span>
				</div>
				<p-divider></p-divider>

				<div class="p-col-12 p-md-12">
					<div class="p-grid">
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('diagnosticoNormal')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('diagnosticoNormal', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.diagnosticoNormal.value&& !f.dermatitisIrritativaContacto.value&& !f.dermatitisAlergicaContacto.value&& !f.eccema.value&& !f.otros.value}"
										formControlName="diagnosticoNormal" inputId="diagnosticoNormal"
										label="Normal" name="diagnosticoNormal"
										[ngModel]="examen.diagnosticoNormal"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('dermatitisIrritativaContacto')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('dermatitisIrritativaContacto', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.diagnosticoNormal.value&& !f.dermatitisIrritativaContacto.value&& !f.dermatitisAlergicaContacto.value&& !f.eccema.value&& !f.otros.value}"
										formControlName="dermatitisIrritativaContacto" inputId="dermatitisIrritativaContacto"
										label="Dermatitis irritativa por contacto" name="dermatitisIrritativaContacto"
										[ngModel]="examen.dermatitisIrritativaContacto"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>

						</div>
					</div>
					<div class="p-grid">
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('dermatitisAlergicaContacto')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('dermatitisAlergicaContacto', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.diagnosticoNormal.value&& !f.dermatitisIrritativaContacto.value&& !f.dermatitisAlergicaContacto.value&& !f.eccema.value&& !f.otros.value}"
										formControlName="dermatitisAlergicaContacto" inputId="dermatitisAlergicaContacto"
										label="Dermatitis alérgica por contacto" name="dermatitisAlergicaContacto"
										[ngModel]="examen.dermatitisAlergicaContacto"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
							<div *ngIf="configForm.findField('eccema')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('eccema', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.diagnosticoNormal.value&& !f.dermatitisIrritativaContacto.value&& !f.dermatitisAlergicaContacto.value&& !f.eccema.value&& !f.otros.value}"
										formControlName="eccema" inputId="eccema"
										label="ECCEMA" name="eccema"
										[ngModel]="examen.eccema"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
					</div>
					<div class="p-grid">
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('otros')" class="p-col-12 p-md-6">
								<div class="p-field-checkbox ">
									<p-checkbox (onChange)="clickCheckBox('otros', $event)"
										binary="true"
										[ngClass]="{'ng-invalid ng-dirty': submitted && !f.diagnosticoNormal.value&& !f.dermatitisIrritativaContacto.value&& !f.dermatitisAlergicaContacto.value&& !f.eccema.value&& !f.otros.value}"
										formControlName="otros" inputId="otros"
										label="Otros" name="otros"
										[ngModel]="examen.otros"
										[disabled]="examen?.modoVista === 'ver'">
									</p-checkbox>
								</div>
							</div>
						</div>
					</div>
					<div class="p-col-12 p-md-12">
						<app-invalid-from-message *ngIf="submitted && !f.diagnosticoNormal.value  && !f.dermatitisIrritativaContacto.value && !f.dermatitisAlergicaContacto.value && !f.eccema.value && !f.otros.value">
						</app-invalid-from-message>
					</div>
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Describa: " [required]="f.otros.value"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('otrosDesc')" class="p-col-12 p-md-6 print_row-full">
							<p [ngClass]="{'print_show-on-print': f.otrosDesc.value.length > 0 && f.otros.value,
								'print_hide-on-print': f.otrosDesc.value.length < 1 }"
							   class="print_hidden-area-before-print print_row-full p-field-word-break">
							   {{f.otrosDesc.value}}
							</p>
							<textarea class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.otrosDesc.invalid}"
								cols="30" formControlName="otrosDesc" id="result" maxlength="250" name="resul" pInputTextarea rows="5"
								[attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.otrosDesc.value.length }}/250
							</small>
							<app-invalid-from-message *ngIf="submitted && f.otrosDesc.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.otrosDesc.errors?.maxlength"
								message="Solo se permiten {{ f.otrosDesc.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="configForm.findSection('Observaciones')" class="print_dont_break">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("Observaciones") }}. Observaciones
					</span>
				</div>
				<p-divider></p-divider>

				<div class="p-col-12 p-md-12">
					<div class="p-grid">
						<div class="p-col-12 p-md-12">
							<app-fiel-title label="Observaciones: " [required]="true"></app-fiel-title>
						</div>
						<div *ngIf="configForm.findField('conclusion')" class="p-col-12 p-md-6 print_row-full">
							<p [ngClass]="{'print_show-on-print': f.conclusion.value.length > 0,
					                'print_hide-on-print': f.conclusion.value.length === 0}"
								class="print_hidden-area-before-print print_row-full p-field-word-break">
								{{f.conclusion.value}}
							</p>
							<textarea class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.conclusion.invalid}"
								cols="30" formControlName="conclusion" id="result" maxlength="4000" name="resul" pInputTextarea rows="5"
								[attr.disabled]="examen?.modoVista === 'ver' ? true : null">
					              </textarea>
							<small style="text-align: end;">
								{{ f.conclusion.value.length }}/4000
							</small>
							<app-invalid-from-message *ngIf="submitted && f.conclusion.errors?.required">
							</app-invalid-from-message>
							<app-invalid-from-message *ngIf="f.conclusion.errors?.maxlength"
								message="Solo se permiten {{ f.conclusion.errors.maxlength.requiredLength  }} caracteres">
							</app-invalid-from-message>
						</div>
					</div>
				</div>
			</div>


			<div class="print_hide-on-print" *ngIf="configForm.findSection('Dictamen medico')">
				<label class="p-title-seccion">
					{{ configForm.findNumberSection("Dictamen medico") }}. Dictamen médico
				</label>
				<p-divider></p-divider>

				<div class="p-grid">

					<div *ngIf="configForm.findField('codigoDictamen')" class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Tipo de dictamen" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;"
							[ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid }">

							<div *ngFor="let item of tiposDictamen" class="p-field-checkbox">

								<p-radioButton name="codigoDictamen" [value]="item.codigo"
									formControlName="codigoDictamen" label="{{ item.descripcion }}"
									[ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid}"
									[disabled]="examen?.modoVista === 'ver'" [(ngModel)]="examen.codigoDictamen">
								</p-radioButton>

							</div>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.codigoDictamen.invalid">
						</app-invalid-from-message>
					</div>


					<div class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Especialidad" required="true"></app-fiel-title>
						<p-dropdown [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoEspecialidad.invalid}"
							[options]="especialidades" formControlName="medicoEspecialidad" placeholder="Seleccione"
							optionLabel="descripcion" optionValue="codigo" [showClear]="true"
							[disabled]="examen?.modoVista === 'ver'">
						</p-dropdown>
						<app-invalid-from-message *ngIf="submitted && f.medicoEspecialidad.invalid">
						</app-invalid-from-message>
					</div>


					<div *ngIf="configForm.findField('medicoNombre')" class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Médico" required="true"></app-fiel-title>
						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoNombre.invalid}"
							alfanumericoDirective formControlName="medicoNombre" id="medico" name="medico"
							maxlength="100" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.medicoNombre.invalid">
						</app-invalid-from-message>
					</div>


					<div class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Matrícula" required="true"></app-fiel-title>
						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoMatricula.invalid}" numberDirective
							formControlName="medicoMatricula" id="medicoMatricula" name="medicoMatricula" maxlength="18"
							pInputText type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.medicoMatricula.invalid"></app-invalid-from-message>
					</div>
				</div>
				<div class="p-grid p-form-footer">
					<div class="p-field p-col-12 p-md-12" style="justify-content: flex-start; display: flex;">
						<button [disabled]="examen?.modoVista === 'ver' ? true : null" pButton pRipple type="button" label="Firmar" (click)="showModalFirma()"></button>
					</div>
					<div class="p-field p-col-12 p-md-12">
						<app-invalid-from-message *ngIf="submitted && medicoFirmaB64 == null" message="Por favor firmar el estudio"></app-invalid-from-message>
					</div>
				</div>
			</div>


			<div *ngIf="configForm.findSection('Adjuntos')" class="p-grid-space print_hide-on-print">
				<label class="p-title-seccion">
					{{ configForm.findNumberSection("Adjuntos") }}. Archivos adjuntos
					<strong *ngIf="attachedFiles.attachedFilesValidQuantity >= 1">:</strong>
					<span style="font-weight: normal;" *ngIf="attachedFiles.data.length >= 1">
						{{ attachedFiles.attachedFilesValidQuantity }}
					</span>
				</label>
				<p-divider></p-divider>

				<app-attach-upload-file [examenNumero]="this.examen?.id"
					[isRequire]="configForm.isAttachedFileRequire" (filesAttachedData)="getAttachedFiles($event)"
					[attachedFilesFromBackend]="this.examen?.attachments" [viewMode]="this.examen?.modoVista"
					[esAunPorEnviar]="this.examen?.aunPorEnviar || false">
				</app-attach-upload-file>

				<app-attached-file-mandatory-message
					*ngIf=" submitted &&  configForm.isAttachedFileRequire && attachedFiles.isEmpty  ">
				</app-attached-file-mandatory-message>
			</div>

			<div class="p-grid p-form-footer">
				<div class="p-col-12 p-md-12" style="justify-content: flex-end; display: flex;">
					<ng-container *ngIf="examen?.modoVista === 'ver'">
						<button pButton pRipple type="button" label="Volver" class="p-button-text"
							(click)="goBack()"></button>
					</ng-container>

					<ng-container *ngIf="examen?.modoVista !== 'ver'">
						<button pButton pRipple type="button" label="Cancelar" class="p-button-text"
							(click)="goBack()"></button>
						<p-button type="submit" label="Guardar" *ngIf="!enviandose"
							[disabled]="examen?.modoVista === 'edit' && !isOnline && !examen?.aunPorEnviar">
						</p-button>
						<p-button type="submit" label="Enviando..." *ngIf="enviandose" disabled="true"></p-button>
					</ng-container>
				</div>
			</div>
      <div class="p-mt-5">
        <app-print-footer [firmaB64]="examen?.firmaB64"
                          [medicoFirmaB64]="medicoFirmaB64"
                          [trabajadorApellidoNombre]="f.apellidoNombre.value"
                          [medicoNombre]="f.medicoNombre?.value"
                          [medicoEspecialidad]="f.medicoEspecialidad.value"
                          [medicoMatricula]="f.medicoMatricula?.value">
        </app-print-footer>
      </div>
		</div>
	</form>

	<p-confirmDialog #cd [closable]="false" [style]="{ width: '500px' }" key="goBackFormEC"
		styleClass="p-dialog-custom">
		<p-footer>
			<button (click)="cd.reject()" class="p-button-text" label="No, volver al examen" pButton
				type="button"></button>
			<button (click)="cd.accept()" label="Si, cancelar carga" pButton type="button"></button>
		</p-footer>

	</p-confirmDialog>
</main>

<section id="modal-firma">
	<app-topaz (datosFirma)="recibirDatosFirma($event)" [displayModalFirma]="displayModalFirma" (closeModal)="closeModalFirma()"></app-topaz>
</section>
